import { createSlice } from '@reduxjs/toolkit'
import {
  REDUX_STATUS_FAILED,
  REDUX_STATUS_IDLE,
  REDUX_STATUS_LOADING,
  REDUX_STATUS_SUCCESS,
} from 'src/consumer/constants'
import { resetStores } from 'src/store'
import { getDoctorRecommendedHealthEntities } from './services/doctorRecommendedHealthEntities'

const initialState = {
  doctorRecommendedHealthEntities: {
    data: null,
    status: REDUX_STATUS_IDLE,
    error: null,
  },
}

const doctorRecommendedHealthEntitiesSlice = createSlice({
  name: 'doctorRecommendedHealthEntitiesStore',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getDoctorRecommendedHealthEntities.pending, (state) => {
        state.doctorRecommendedHealthEntities.status = REDUX_STATUS_LOADING
      })
      .addCase(getDoctorRecommendedHealthEntities.fulfilled, (state, action) => {
        state.doctorRecommendedHealthEntities.status = REDUX_STATUS_SUCCESS
        state.doctorRecommendedHealthEntities.data = action.payload
      })
      .addCase(getDoctorRecommendedHealthEntities.rejected, (state, action) => {
        state.doctorRecommendedHealthEntities.status = REDUX_STATUS_FAILED
        state.doctorRecommendedHealthEntities.error = action.payload
      })
      .addCase(resetStores, () => initialState)
  },
})

export const doctorRecommendedHealthEntitiesReducer = doctorRecommendedHealthEntitiesSlice.reducer

export const selectDoctorRecommendedHealthEntities = (state) => state.doctorRecommendedHealthEntitiesStore.doctorRecommendedHealthEntities
